import { Component, Input } from '@angular/core';
import { ILoadingOverlayAngularComp } from 'ag-grid-angular';
import { Observable } from 'rxjs';
import { ILoadingOverlayParams } from 'ag-grid-community';

@Component({
  standalone: false,
  selector: 'mm-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent implements ILoadingOverlayAngularComp{
  @Input() loading: Observable<{ loading: boolean }>
  // When true, the spinner will not block user input, meaning they can click through it, but it will not scroll the page to focus on it.
  @Input() makeInert: boolean = true;
  lockModalVersion: boolean = false;

  loadingFromParams: boolean = false;
  params: ILoadingOverlayParams & { loadingFn: () => boolean, lockModalVersion: boolean };

  agInit(params: ILoadingOverlayParams & { loadingFn: () => boolean, lockModalVersion: boolean }): void {
    this.params = params;
    this.loadingFromParams = params.loadingFn();
    this.lockModalVersion = params.lockModalVersion;
   }
}